import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  GetProfileByUsername200,
  GetProfileByUsername401,
  GetProfileByUsername404,
  GetProfileByUsername500,
  GetUserProfile200,
  GetUserProfile401,
  GetUserProfile404,
  GetUserProfile500,
  UpdateUserProfile200,
  UpdateUserProfile401,
  UpdateUserProfile403,
  UpdateUserProfile404,
  UpdateUserProfile500,
  UpdateUserProfileBody
} from './types'


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;



/**
 * @summary 사용자 프로필 조회
 */
export const getUserProfile = (
    userId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserProfile200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/users/${userId}/profile`,options
    );
  }


export const getGetUserProfileQueryKey = (userId: string,) => {
    return [`https://api.ugot.uk/api/users/${userId}/profile`] as const;
    }

    
export const getGetUserProfileInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getUserProfile>>, TError = AxiosError<GetUserProfile401 | GetUserProfile404 | GetUserProfile500>>(userId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserProfileQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserProfile>>> = ({ signal }) => getUserProfile(userId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(userId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserProfileInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getUserProfile>>>
export type GetUserProfileInfiniteQueryError = AxiosError<GetUserProfile401 | GetUserProfile404 | GetUserProfile500>

/**
 * @summary 사용자 프로필 조회
 */
export const useGetUserProfileInfinite = <TData = Awaited<ReturnType<typeof getUserProfile>>, TError = AxiosError<GetUserProfile401 | GetUserProfile404 | GetUserProfile500>>(
 userId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserProfileInfiniteQueryOptions(userId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetUserProfileQueryOptions = <TData = Awaited<ReturnType<typeof getUserProfile>>, TError = AxiosError<GetUserProfile401 | GetUserProfile404 | GetUserProfile500>>(userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserProfileQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserProfile>>> = ({ signal }) => getUserProfile(userId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(userId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getUserProfile>>>
export type GetUserProfileQueryError = AxiosError<GetUserProfile401 | GetUserProfile404 | GetUserProfile500>

/**
 * @summary 사용자 프로필 조회
 */
export const useGetUserProfile = <TData = Awaited<ReturnType<typeof getUserProfile>>, TError = AxiosError<GetUserProfile401 | GetUserProfile404 | GetUserProfile500>>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserProfileQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary 사용자 프로필 업데이트
 */
export const updateUserProfile = (
    userId: string,
    updateUserProfileBody: UpdateUserProfileBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateUserProfile200>> => {
    
    return axios.put(
      `https://api.ugot.uk/api/users/${userId}/profile`,
      updateUserProfileBody,options
    );
  }



export const getUpdateUserProfileMutationOptions = <TError = AxiosError<UpdateUserProfile401 | UpdateUserProfile403 | UpdateUserProfile404 | UpdateUserProfile500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserProfile>>, TError,{userId: string;data: UpdateUserProfileBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserProfile>>, TError,{userId: string;data: UpdateUserProfileBody}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserProfile>>, {userId: string;data: UpdateUserProfileBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  updateUserProfile(userId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserProfile>>>
    export type UpdateUserProfileMutationBody = UpdateUserProfileBody
    export type UpdateUserProfileMutationError = AxiosError<UpdateUserProfile401 | UpdateUserProfile403 | UpdateUserProfile404 | UpdateUserProfile500>

    /**
 * @summary 사용자 프로필 업데이트
 */
export const useUpdateUserProfile = <TError = AxiosError<UpdateUserProfile401 | UpdateUserProfile403 | UpdateUserProfile404 | UpdateUserProfile500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserProfile>>, TError,{userId: string;data: UpdateUserProfileBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateUserProfile>>,
        TError,
        {userId: string;data: UpdateUserProfileBody},
        TContext
      > => {

      const mutationOptions = getUpdateUserProfileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary 사용자 이름으로 프로필 조회
 */
export const getProfileByUsername = (
    username: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetProfileByUsername200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/users/username/${username}/profile`,options
    );
  }


export const getGetProfileByUsernameQueryKey = (username: string,) => {
    return [`https://api.ugot.uk/api/users/username/${username}/profile`] as const;
    }

    
export const getGetProfileByUsernameInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getProfileByUsername>>, TError = AxiosError<GetProfileByUsername401 | GetProfileByUsername404 | GetProfileByUsername500>>(username: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfileByUsername>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileByUsernameQueryKey(username);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileByUsername>>> = ({ signal }) => getProfileByUsername(username, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(username),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfileByUsername>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProfileByUsernameInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileByUsername>>>
export type GetProfileByUsernameInfiniteQueryError = AxiosError<GetProfileByUsername401 | GetProfileByUsername404 | GetProfileByUsername500>

/**
 * @summary 사용자 이름으로 프로필 조회
 */
export const useGetProfileByUsernameInfinite = <TData = Awaited<ReturnType<typeof getProfileByUsername>>, TError = AxiosError<GetProfileByUsername401 | GetProfileByUsername404 | GetProfileByUsername500>>(
 username: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProfileByUsername>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetProfileByUsernameInfiniteQueryOptions(username,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetProfileByUsernameQueryOptions = <TData = Awaited<ReturnType<typeof getProfileByUsername>>, TError = AxiosError<GetProfileByUsername401 | GetProfileByUsername404 | GetProfileByUsername500>>(username: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfileByUsername>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileByUsernameQueryKey(username);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileByUsername>>> = ({ signal }) => getProfileByUsername(username, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(username),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfileByUsername>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProfileByUsernameQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileByUsername>>>
export type GetProfileByUsernameQueryError = AxiosError<GetProfileByUsername401 | GetProfileByUsername404 | GetProfileByUsername500>

/**
 * @summary 사용자 이름으로 프로필 조회
 */
export const useGetProfileByUsername = <TData = Awaited<ReturnType<typeof getProfileByUsername>>, TError = AxiosError<GetProfileByUsername401 | GetProfileByUsername404 | GetProfileByUsername500>>(
 username: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfileByUsername>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetProfileByUsernameQueryOptions(username,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



